import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PlaceIcon from '@mui/icons-material/Place';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PaymentsIcon from '@mui/icons-material/Payments';
import { metaStripStyles } from './eventDetailsStyles';

const metaItems = [
  { key: 'start', label: 'Starts', icon: CalendarMonthIcon },
  { key: 'venue', label: 'Venue', icon: PlaceIcon },
  { key: 'price', label: 'Price', icon: PaymentsIcon },
  { key: 'availability', label: 'Availability', icon: ConfirmationNumberIcon },
];

const EventMetaStrip = ({ start, venue, price, availability }) => {
  const values = { start, venue, price, availability };
  const availableItems = metaItems
    .map((item) => ({ ...item, value: values[item.key] }))
    .filter(({ value }) => value !== null
      && value !== undefined
      && String(value).trim() !== ''
      && String(value).trim() !== '-');

  if (!availableItems.length) return null;

  return (
    <Container maxWidth="lg" sx={metaStripStyles.shell}>
      <Card sx={metaStripStyles.card}>
        <CardContent>
          <Grid container spacing={2}>
            {availableItems.map((item) => {
              const MetaIcon = item.icon;
              return (
                <Grid size={{ xs: 12, sm: 6, md: 12 / availableItems.length }} key={item.key}>
                  <Stack direction="row" spacing={1.25} alignItems="center">
                    <MetaIcon sx={metaStripStyles.icon} />
                    <Box>
                      <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                      <Typography variant="body2" sx={metaStripStyles.value}>{item.value}</Typography>
                    </Box>
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};

export default EventMetaStrip;
